/* eslint-disable import/no-anonymous-default-export*/
// eslint-disable import/no-anonymous-default-export
// File was autogenerated by tools/generateLabels.js script
import pl from  './translations/validationMessages.pl';

export default {
    pl,
};
